import type { FaireProductEntity } from "../../entity_types/product";

export const p_4tcqzu6vgt: FaireProductEntity = {
  token: "p_4tcqzu6vgt",
  type: "product",
  name: "Signature: Rainier Candle | 12oz.",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/2c3b03c4528d9ac891b6ea1fb5cad1e38ac902c11467f267fe00f710e5008a20.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6c53999144cc53f127560564f44cd32f88d11a011c3b542ff9eaabd9329a8f6.jpeg",
    "https://cdn.faire.com/fastly/f27788a8f2c9574da5cd694fa2b69729b1f4ddb959fce9b18c810cdb40f8d517.jpeg",
    "https://cdn.faire.com/fastly/d405b04297f1db54683bc3652486215d513b9f09ab78d06c0452179550a12f31.jpeg",
    "https://cdn.faire.com/fastly/695b151a8755c6cbd1f652b52f1d7747a31ba71940d94c488b29550bca2b9319.jpeg",
    "https://cdn.faire.com/fastly/7436ceb4e7acdba4b7ac65bef31ab2abf283736a73622dc4f576eec491a3ed5e.jpeg",
  ],
  priceDollars: 22,
  description:
    "Inspired by the indigenous plant varieties of the Pacific Northwest, a broad base of Redwood gives way to the strong, clean notes of grassy and verdant fern and lemon balm, while top notes of lupine and lavender add a touch of earthy but freshly cut florals.\n\nIndigenous Notes: Fern, Lupine, Lavender, Redwood, Lemon Balm\n\n• SOY & COCONUT WAX CANDLE | 100% COTTON WICK\n• 12 oz. | 70+ HOUR BURN TIME\n• $1 FOR GOOD: NORTH OLYMPIC LAND TRUST\n\nWe give back $1 per Signature Candle sold to vetted non-profit organizations working in the areas indigenous to our fragrance inspirations. In our efforts, we hope to work together toward the goal of ecological, societal, & environmental sustainability. Since our company's founding in 2019, we have donated over $250,000 to partnering causes.\n\n\n\n\nKeywords for your SEO:\nBotanica, Candle, boutique candle, fine fragrance, soy wax, coconut wax, ethical, made. inlos angeles, made. inthe usa, america, give back component, donation, non profit, environmentalism, ecology, humanitarian, ethical gifts, give back gifts, giving, holiday, candle shop, best selling gifts, quality candles, fragranced candles, essential oils, handmade, hand poured, women owned",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:51.437Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
